import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiService from "../services/ApiService";
import Loader from "../components/Loader"; 

const Setting = () => {
  const navigate = useNavigate();
  const admin = JSON.parse(localStorage.getItem('admin'));
  const currency = process.env.REACT_APP_CURRENCY;

  const [isLoader, setIsLoader] = useState(false);
  const [activeTab, setActiveTab] = useState('loyalty');
  const [formData, setFormData] = useState({
    platform_fee: '',
    vat: '',
    android_version: '',
    ios_version: '',
    aed_points: '',
    reward_aed_points: '',
    signup_points: '',
    payment_mode: '',
    under_maintenance: false,
    payment_methods: [] // Initialize payment methods as empty array
  });

  useEffect(() => {
    getSingleData();
  }, []);

  const getSingleData = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `getSettings`,
      });
      const data = response.data;
      if (data.status) {
        // Ensure payment_methods is always an array
        const settingsData = data.data;
        if (!Array.isArray(settingsData.payment_methods)) {
          settingsData.payment_methods = [];
        }
        settingsData.under_maintenance = settingsData.under_maintenance || false;
        setFormData(settingsData);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: "POST",
        url: "updateSetting", 
        data: formData
      });
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.log(error);
      setIsLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handlePaymentMethodChange = (e, method) => {
    const { checked } = e.target;
    setFormData(prev => ({
      ...prev,
      payment_methods: checked
        ? [...prev.payment_methods, method] // Add if checked
        : prev.payment_methods.filter(m => m !== method) // Remove if unchecked
    }));
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              Setting
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <a href="/TimeLogger/admin/" className="text-muted text-hover-primary">Home</a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">Setting</li>
            </ul>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-fluid">
          <div className="card">
            <div className="card-body pt-0">
              <div className="mb-8 text-center"></div>
              
              {/* Tabs Navigation */}
              <ul className="nav nav-tabs nav-line-tabs mb-5 fs-6">
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'loyalty' ? 'active' : ''}`} 
                    onClick={() => setActiveTab('loyalty')}
                  >
                    Loyalty Points
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'platform' ? 'active' : ''}`} 
                    onClick={() => setActiveTab('platform')}
                  >
                    Platform Settings
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'app' ? 'active' : ''}`} 
                    onClick={() => setActiveTab('app')}
                  >
                    App Settings
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'payment' ? 'active' : ''}`} 
                    onClick={() => setActiveTab('payment')}
                  >
                    Payment Methods
                  </button>
                </li>
              </ul>

              <div className="row g-9 mb-8">
                <div className="col-md-12">
                  <form className="form" onSubmit={handleSubmit}>
                    {/* Loyalty Points Tab */}
                    {activeTab === 'loyalty' && (
                      <div className="row">
                        <div className="col-md-6 my-3">
                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">1 {currency} to Loyalty Points (Redeem)</span>
                          </label>
                          <input
                            type="number"
                            step={0.01}
                            name="aed_points"
                            value={formData.aed_points}
                            required
                            onChange={handleChange}
                            className="form-control form-control-solid"
                            placeholder="1 AED to Loyalty Points"
                          />
                        </div>
                        <div className="col-md-6 my-3">
                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">1 {currency} to Loyalty Points (Reward)</span>
                          </label>
                          <input
                            type="number"
                            step={0.01}
                            name="reward_aed_points"
                            value={formData.reward_aed_points}
                            required
                            onChange={handleChange}
                            className="form-control form-control-solid"
                            placeholder="1 AED to Loyalty Points"
                          />
                        </div>
                        <div className="col-md-6 my-3">
                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="">Max Redeem Points (Cap - %)</span>
                          </label>
                          <input
                            type="number"
                            min={1}
                            max={100}
                            name="max_redeem_points"
                            value={formData.max_redeem_points}
                            onChange={handleChange}
                            className="form-control form-control-solid"
                            placeholder="Max Redeem Points (Cap)"
                          />
                        </div>
                        <div className="col-md-6 my-3">
                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="">Signup Points</span>
                          </label>
                          <input
                            type="number"
                            step={0.01}
                            name="signup_points"
                            value={formData.signup_points}
                            onChange={handleChange}
                            className="form-control form-control-solid"
                            placeholder="Signup Points"
                          />
                        </div>
                        <div className="col-md-6 my-3">
                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">Loalty Discount POS ID</span>
                          </label>
                          <input
                            type="text"
                            name="loyalty_pos_id"
                            value={formData.loyalty_pos_id}
                            required
                            onChange={handleChange}
                            className="form-control form-control-solid"
                            placeholder="Enter Loalty Discount POS ID"
                          />
                        </div>
                        <div className="col-md-2 my-3">
                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="">Loyalty Card Bg</span>
                          </label>
                          <input
                            type="color"
                            name="loyalty_card_bg"
                            value={formData.loyalty_card_bg}
                            onChange={handleChange}
                            className="form-control form-control-solid p-2"
                            placeholder="Loyalty Card Bg"
                          />
                        </div>
                      </div>
                    )}

                    {/* Platform Settings Tab */}
                    {activeTab === 'platform' && (
                      <div className="row">
                        <div className="col-md-6 my-3">
                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">Platform Fee ({currency})</span>
                          </label>
                          <input
                            type="number"
                            step={0.01}
                            name="platform_fee"
                            value={formData.platform_fee}
                            onChange={handleChange}
                            required
                            className="form-control form-control-solid"
                            placeholder="Enter Platform Fee"
                          />
                        </div>
                        <div className="col-md-6 my-3">
                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">Vat (%)</span>
                          </label>
                          <input
                            type="number"
                            step={0.01}
                            name="vat"
                            value={formData.vat}
                            required
                            onChange={handleChange}
                            className="form-control form-control-solid"
                            placeholder="Enter Vat"
                          />
                        </div>
                        <div className="col-md-6 my-3">
                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">Delivery Charges POS ID</span>
                          </label>
                          <input
                            type="text"
                            name="delivery_pos_id"
                            value={formData.delivery_pos_id}
                            required
                            onChange={handleChange}
                            className="form-control form-control-solid"
                            placeholder="Enter Delivery Charges POS ID"
                          />
                        </div>
                        <div className="col-md-6 my-3">
                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="">Under Maintenance</span>
                          </label>
                          <div className="form-check form-switch form-check-custom form-check-solid">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="under_maintenance"
                              checked={formData.under_maintenance}
                              onChange={handleChange}
                            />
                            <label className="form-check-label ms-3">
                              {formData.under_maintenance ? 'Enabled' : 'Disabled'}
                            </label>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* App Settings Tab */}
                    {activeTab === 'app' && (
                      <div className="row">
                        <div className="col-md-6 my-3">
                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">Android Version</span>
                          </label>
                          <input
                            type="number"
                            step={0.01}
                            name="android_version"
                            value={formData.android_version}
                            onChange={handleChange}
                            required
                            className="form-control form-control-solid"
                            placeholder="Enter Android Version"
                          />
                        </div>
                        <div className="col-md-6 my-3">
                          <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">IOS Version</span>
                          </label>
                          <input
                            type="number"
                            step={0.01}
                            name="ios_version"
                            value={formData.ios_version}
                            required
                            onChange={handleChange}
                            className="form-control form-control-solid"
                            placeholder="Enter IOS Version"
                          />
                        </div>
                        <div className="col-md-6 my-3">
                          <label className="d-flex required align-items-center fs-6 fw-semibold mb-2">
                            <span className="">Payment Mode</span>
                          </label>
                          <select 
                            name="payment_mode" 
                            required 
                            className='form-select'
                            value={formData.payment_mode}
                            onChange={handleChange}
                          >
                            <option value="test">Test</option>
                            <option value="live">Live</option>
                          </select>
                        </div>
                      </div>
                    )}

                    {/* Payment Methods Tab */}
                    {activeTab === 'payment' && (
                      <div className="row">
                        <div className="col-md-12 fv-row">
                          <h6>Payment Methods</h6>
                          <div className="row">
                            <div className="col-3">
                              <label className="fs-6 fw-semibold mb-2">Online (Card)</label>
                              <div className="form-check form-switch mt-2">
                                <input 
                                  className="form-check-input" 
                                  type="checkbox"  
                                  checked={formData.payment_methods.includes('Card')} 
                                  onChange={(e) => handlePaymentMethodChange(e, 'Card')}
                                  id="cardPayment" 
                                />
                              </div>
                            </div>
                            <div className="col-3">
                              <label className="fs-6 fw-semibold mb-2">Cash on Delivery (COD)</label>
                              <div className="form-check form-switch mt-2">
                                <input 
                                  className="form-check-input" 
                                  type="checkbox"  
                                  checked={formData.payment_methods.includes('COD')} 
                                  onChange={(e) => handlePaymentMethodChange(e, 'COD')}
                                  id="codPayment" 
                                />
                              </div>
                            </div>
                            <div className="col-3">
                              <label className="fs-6 fw-semibold mb-2">Cash on Pickup (COP)</label>
                              <div className="form-check form-switch mt-2">
                                <input 
                                  className="form-check-input" 
                                  type="checkbox"  
                                  checked={formData.payment_methods.includes('COP')} 
                                  onChange={(e) => handlePaymentMethodChange(e, 'COP')}
                                  id="copPayment" 
                                />
                              </div>
                            </div>
                            <div className="col-3">
                              <label className="fs-6 fw-semibold mb-2">Apple Pay</label>
                              <div className="form-check form-switch mt-2">
                                <input 
                                  className="form-check-input" 
                                  type="checkbox"  
                                  checked={formData.payment_methods.includes('Apple Pay')} 
                                  onChange={(e) => handlePaymentMethodChange(e, 'Apple Pay')}
                                  id="applePayPayment" 
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <button
                      type="submit"
                      className="btn btn-base my-5"
                      disabled={isLoader}
                    >
                      <span className="indicator-label">
                        {!isLoader ? "Update Settings" : <Loader size="20" text="Updating" />}
                      </span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setting;